import { IAllMetaTag } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

async function getMetaTagList(): Promise<AxiosResponse<FetchResult<IAllMetaTag[]>>> {
  const response = await instance.get(`/meta-tags`);
  return response;
}

const useFetchMetaTagList = () => {
  const { data: originalData, refetch } = useQuery({
    queryKey: ['get', `/meta-tags`],
    queryFn: () => getMetaTagList(),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: false
  });

  const data = originalData?.data.data;

  return { data, refetch };
};

export default useFetchMetaTagList;
